import { Component, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { IconDirective } from '@coreui/icons-angular';
import { BugReport } from '../../../../models/bug-reports/bug-report.model';
import { BugCategoryType } from '../../../../enums/bug-reports/bug-category-type.enum';
import { DateService } from '../../../../services/date.service';

@Component({
  selector: 'app-bug-report-detail-modal',
  templateUrl: './bug-report-detail-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, RouterModule, IconDirective, TooltipModule]
})
export class BugReportDetailModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  dateService = inject(DateService);

  report: BugReport | null = null;

  show(report: BugReport): void {
    this.report = report;
    this.modal.show();
  }

  getBugTypeName(bugType: number): string {
    switch (bugType) {
      case BugCategoryType.CreditLost: return 'Credit Lost';
      case BugCategoryType.BuyIssue: return 'Buy Issue';
      case BugCategoryType.InGameIssue: return 'In-Game Issue';
      case BugCategoryType.GameIssue: return 'Game Issue';
      case BugCategoryType.Other: return 'Other';
      default: return 'None';
    }
  }

  getDisplayName(report: BugReport): string {
    return report.userDisplayname ? report.userDisplayname : 'Guest' + report.userId;
  }

  getLocaleFlagIconName(locale: string): string {
    if (!locale) return '';
    const parts = locale.split('_');
    const countryCode = (parts.length > 1 ? parts[1] : parts[0]).toLowerCase();
    return 'cif' + countryCode.charAt(0).toUpperCase() + countryCode.slice(1);
  }
}
